import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {UserAuthorityModule} from './main/user-authority/user-authority.module';
import {HomeModule} from './home/home.module';
import {FuseSharedModule} from '../../@fuse/shared.module';
import {ErrorModule} from './error/error.module';
import {Html5Module} from './html5/html5.module';


const lazyRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./main/login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'statistics',
        loadChildren: () => import('./main/statistics/statistics.module').then(m => m.StatisticsModule)
    },
    {
        path: 'admin',
        loadChildren: () => import('./main/r2-cloud-admin/r2-cloud-admin.module').then(m => m.R2CloudAdminModule)
    },
    {
        path: 'marketplace',
        loadChildren: () => import('./main/marketplace/marketplace.module').then(m => m.MarketplaceModule)
    },
    /* R2CLOUD-1094: monitoring descomissionado (backend scale-zero em PROD) - rota desativada
    {
        path: 'monitoring',
        loadChildren: () => import('./main/monitoring/monitoring.module').then(m => m.MonitoringModule)
    },
    */
    {
        path: 'partners/hipcom',
        loadChildren: () => import('./main/partners/hipcom/hipcom.module').then(m => m.HipcomModule)
    },
    {
        path: 'status',
        loadChildren: () => import('./main/status/status.module').then(m => m.StatusModule)
    },
    {
        path: 'customer-groups',
        loadChildren: () => import('./main/customer-groups-dashboard/customer-groups-dashboard.module').then(m => m.CustomerGroupsDashboardModule)
    },
    {
        path: 'chat-ai',
        loadChildren: () => import('./main/ai/ai.module').then(m => m.AiModule)
    },
    {
        path: 'server-plugin',
        loadChildren: () => import('./main/server-plugin/server-plugin.module').then(m => m.DotNetServerPluginModule)
    },
    {
        path: 'custom-layout',
        loadChildren: () => import('./main/custom-layout/custom-layout.module').then(m => m.CustomLayoutModule)
    },
    {
        path: 'guac-server',
        loadChildren: () => import('./main/guac/guac.module').then(m => m.GuacModule)
    },
    {
        path: 'gateway-server',
        loadChildren: () => import('./main/gateway-server/gateway-server.module').then(m => m.GatewayServerModule)
    },
    {
        path: 'r2-desk',
        loadChildren: () => import('./main/r2-desk/r2-desk.module').then(m => m.R2DeskModule)
    },
    {
        path: 'iam',
        loadChildren: () => import('./main/iam/iam.module').then(m => m.IAMModule)
    },
    {
        path: 'register',
        loadChildren: () => import('./main/register/register.module').then(m => m.RegisterModule)
    },
    {
        path: 'customer-group',
        loadChildren: () => import('./main/customer-group/customer-group.module').then(m => m.CustomerGroupModule)
    },
    {
        path: 'manager-user',
        loadChildren: () => import('./main/manager-user/manager-user.module').then(m => m.ManagerUserModule)
    },
    {
        path: 'desktop-server',
        loadChildren: () => import('./main/desktop-server/desktop-server.module').then(m => m.DesktopServerModule)
    },
    {
        path: 'ad-user',
        loadChildren: () => import('./main/ad-user/ad-user.module').then(m => m.AdUserModule)
    },
    {
        path: 'remote-app',
        loadChildren: () => import('./main/remote-app/remote-app.module').then(m => m.RemoteAppModule)
    },
    {
        path: 'ad-domain',
        loadChildren: () => import('./main/ad-domain/ad-domain.module').then(m => m.AdDomainModule)
    },
    {
        path: 'project',
        loadChildren: () => import('./main/project/project.module').then(m => m.ProjectModule)
    },
    {
        path: 'desktop',
        loadChildren: () => import('./main/desktop/desktop.module').then(m => m.DesktopModule)
    },
    {
        path: 'digital-certificate',
        loadChildren: () => import('./main/digital-certificate/digital-certificate.module').then(m => m.DigitalCertificateModule)
    },
    {
        path: 'manager-user-access-period-created-edit',
        loadChildren: () => import('./main/manager-user-access-period/manager-use-access-period.module').then(m => m.ManagerUserAccessPeriodModule)
    },
    {
        path: 'users-pool',
        loadChildren: () => import('./main/ad-user-pool/ad-user-pool.module').then(m => m.AdUserPoolModule)
    },
    {
        path: 'manager-user-contingency',
        loadChildren: () => import('./main/manager-user-contingency/manager-user-contingency.module').then(m => m.ManagerUserContingencyModule)
    },
    {
        path: 'manager-user-vpn',
        loadChildren: () => import('./main/manager-user-vpn/manager-user-vpn.module').then(m => m.ManagerUserVpnModule)
    },
    {
        path: 'my-uploads',
        loadChildren: () => import('./main/my-uploads/my-uploads.module').then(m => m.MyUploadsModule)
    },
    {
        path: 'my-prints',
        loadChildren: () => import('./main/my-prints/my-prints.module').then(m => m.MyPrintsModule)
    },
    {
        path: 'my-docs',
        loadChildren: () => import('./main/my-docs/my-docs.module').then(m => m.MyDocsModule)
    },
    {
        path: 'customer',
        loadChildren: () => import('./main/customer/customer.module').then(m => m.CustomerModule)
    },
    {
        path: 'ad-group',
        loadChildren: () => import('./main/ad-group/ad-group.module').then(m => m.AdGroupModule)
    },
    {
        path: 'profile',
        loadChildren: () => import('./main/profile/profile.module').then(m => m.ProfileModule)
    },
    {path: 'forgot-password', redirectTo: '/login/forgot-password', pathMatch: 'full'},
    {path: 'iam-roles', redirectTo: '/iam/roles', pathMatch: 'full'},
    {path: 'iam-role-customer-group-manager-user', redirectTo: '/iam/role-customer-group-manager-user', pathMatch: 'full'},
    {path: 'manager-user-permissions', redirectTo: '/manager-user/permissions', pathMatch: 'full'},
];

@NgModule({
    imports: [
        CommonModule,
        FuseSharedModule,
        RouterModule.forChild(lazyRoutes),
        UserAuthorityModule,
        HomeModule,
        ErrorModule,
        Html5Module,
    ],
    exports: [],
    declarations: []


})
export class KluhManagerModule {
}
